import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Overview from "./pages/Overview";
import Solution from "./pages/Solution";
import Integration from "./pages/Integration";
import Demo from "./pages/Demo";
import GetStarted from "./pages/GetStarted";
import EvenessBlog from "./pages/EvenessBlog";
import EvenessBlogDetails from "./pages/EvenessBlogDetails";
import ScrollToTop from "./components/ScrollToTop";
import AiSizingSoftware from "./pages/AiSizingSoftware";
import ReduceFashionReturns from "./pages/ReduceFashionReturns";
import ShopifyAiSizing from "./pages/ShopifyAiSizing";

function App() {
  return (
    <Router>
      <Toaster position="top-center" />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/overview" replace />} />
        <Route path="/overview" element={<Overview />} />
        <Route path="/solutions" element={<Solution />} />
        <Route path="/integration" element={<Integration />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/get-started" element={<GetStarted />} />
        <Route path="/ai-sizing-software" element={<AiSizingSoftware />} />
        <Route path="/reduce-fashion-returns" element={<ReduceFashionReturns />} />
        <Route path="/shopify-ai-sizing" element={<ShopifyAiSizing />} />
        <Route path="/blog" element={<EvenessBlog />} />
        <Route path="/blog/:slug" element={<EvenessBlogDetails />} />
      </Routes>
    </Router>
  );
}

export default App;
